import React, { useEffect, useState } from 'react';
import { Container, Table, Spinner, Button, Modal, Form, Image } from 'react-bootstrap';
import DynamicCloseButton from './DynamicCloseButton';
import { get, post } from '../utils/api';
import { useToast } from './ToastContext';

const MyPrescriptions = () => {
  const [prescriptions, setPrescriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const { showToast } = useToast();

  useEffect(() => {
    fetchPrescriptions();
  }, []);

  const fetchPrescriptions = async () => {
    try {
      const { data } = await get('/prescriptions/my');
      setPrescriptions(data);
    } catch (error) {
    }
    setLoading(false);
  };

  const handleShowUploadModal = () => setShowUploadModal(true);
  const handleCloseUploadModal = () => setShowUploadModal(false);

  const handleShowDetailsModal = async (prescription) => {
    setSelectedPrescription(prescription);
    setShowDetailsModal(true);
    try {
      const { data } = await get(`/prescriptions/${prescription.prescription_id}`);
      setSelectedPrescription(data);
    } catch (error) {
    }
  };

  const handleCloseDetailsModal = () => {
    setShowDetailsModal(false);
    setSelectedPrescription(null);
  };

  const handleFileChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!imageFile) {
      showToast('Please select a file to upload.', 'danger');
      return;
    }

    const formData = new FormData();
    formData.append('prescriptionImage', imageFile);

    try {
      await post('/prescriptions', formData);
      showToast('Prescription uploaded successfully!', 'success');
      handleCloseUploadModal();
      fetchPrescriptions();
    } catch (error) {
      showToast('Failed to upload prescription.', 'danger');
    }
  };

  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  if (loading) {
    return (
      <Container className="text-center mt-5">
        <Spinner animation="border" />
      </Container>
    );
  }

  return (
    <Container>
      <h2 className="my-4">My Prescriptions</h2>
      <Button onClick={handleShowUploadModal} className="mb-3">Upload Prescription</Button>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Prescription ID</th>
            <th>Upload Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {prescriptions.length > 0 ? (
            prescriptions.map((prescription) => (
              <tr key={prescription.prescription_id}>
                <td>{prescription.prescription_id}</td>
                <td>{formatDate(prescription.upload_date)}</td>
                <td>{prescription.status.toUpperCase()}</td>
                <td>
                  <Button variant="info" size="sm" onClick={() => handleShowDetailsModal(prescription)}>
                    View Details
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="text-center">No prescriptions found.</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal show={showUploadModal} onHide={handleCloseUploadModal}>
        <Modal.Header>
          <Modal.Title>Upload Prescription</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Prescription Image</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <DynamicCloseButton variant="secondary" onClick={handleCloseUploadModal}>Close</DynamicCloseButton>
          <Button variant="primary" onClick={handleUpload}>
            Upload
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDetailsModal} onHide={handleCloseDetailsModal}>
        <Modal.Header>
          <Modal.Title>Prescription Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedPrescription ? (
            <div>
              <p><strong>Prescription ID:</strong> {selectedPrescription.prescription_id}</p>
              <p><strong>Upload Date:</strong> {formatDate(selectedPrescription.upload_date)}</p>
              <p><strong>Status:</strong> {selectedPrescription.status.toUpperCase()}</p>
              <Image src={selectedPrescription.image_url} fluid />
            </div>
          ) : (
            <Spinner animation="border" />
          )}
        </Modal.Body>
        <Modal.Footer>
          <DynamicCloseButton variant="secondary" onClick={handleCloseDetailsModal}>Close</DynamicCloseButton>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default MyPrescriptions;
